import tinycolor from 'tinycolor2';

export default function getTextColor(backgroundColor: string, idealTextColor: string) {
    if (tinycolor.readability(idealTextColor, backgroundColor) >= 3) {
        return idealTextColor;
    } else {
        return tinycolor.mostReadable(backgroundColor, ['#000', '#fff']).toHexString();
    }
}

/**
 * A muted grey for placeholder text — full-contrast black/white (what
 * `getTextColor` picks for real text) reads as too strong for a
 * placeholder, but a fixed grey can end up nearly invisible depending on
 * whether the theme color is dark or light. Picks whichever grey shade
 * actually shows up against it.
 */
export function getPlaceholderColor(backgroundColor: string): string {
    return tinycolor(backgroundColor).isDark() ? '#9ca3af' : '#4b5563';
}
